import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=24a8114f&scoped=true&"
import script from "./WizardFooter.vue?vue&type=script&lang=js&"
export * from "./WizardFooter.vue?vue&type=script&lang=js&"
import style0 from "./WizardFooter.vue?vue&type=style&index=0&id=24a8114f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8114f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
